import { useEffect } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAdminScopeOptional } from '@/contexts/AdminScopeContext';

/**
 * Tax year dropdown for the admin app. Renders only when inside AdminScopeProvider.
 */
export function AdminTaxYearSelector() {
  const scope = useAdminScopeOptional();
  if (!scope || scope.isLoading || scope.availableYears.length === 0) {
    return null;
  }

  const availableYears = scope.availableYears;
  const selectedYear = scope.selectedYear;
  const valueInList = availableYears.includes(selectedYear);
  const displayValue = valueInList ? selectedYear : availableYears[0];

  useEffect(() => {
    if (!valueInList) {
      scope.setSelectedYear(displayValue);
    }
  }, [valueInList, displayValue, scope.setSelectedYear]);

  return (
    <Select
      key={displayValue}
      value={String(displayValue)}
      onValueChange={(v) => scope.setSelectedYear(Number(v))}
    >
      <SelectTrigger className="w-[100px] h-9">
        <SelectValue placeholder="Year" />
      </SelectTrigger>
      <SelectContent>
        {availableYears.map((year) => (
          <SelectItem key={year} value={String(year)}>
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
